import { core } from '@/core'
import Basic from '@basic'
import { Input, SelectDropdown, Scrollbar, Option } from '@bag'

const util = {
  pullInput(opt, tar) {
    const option = {
      type: 'text',
      placeholder: opt.placeholder,
      readonly: true,
      suffix: 'angle-up',
    }
    const input = new Input(Object.assign({}, opt, option))
    input.members.suffixIcon.addClass('select__caret')
    tar.unit.append(input.unit)
    return input
  },
  pullDropdown(opt, tar) {
    const selectDropdown = new SelectDropdown({})
    tar.unit.append(selectDropdown.unit)
    return selectDropdown
  },
  pullScroll(opt, tar) {
    const option = {
      tag: 'ul',
      viewClass: 'select-dropdown__list',
      wrapClass: 'select-dropdown__wrap',
    }
    const scroll = new Scrollbar(option)
    tar.dropdown.slot = scroll.unit
    return scroll
  },
  pullOption(opt, tar, value) {
    const { id = 'id', text = 'text' } = opt
    if ($.type(value) === 'array') {
      const div = $('<div></div>')
      if (value.length === 0) tar.scroll.slot = tar.members.empty.text('无数据')
      else {
        tar.members.empty.detach()
        tar.members.option = value.map(item => {
          const value = item[id]
          const label = item[text]
          const option = new Option(Object.assign({}, opt, { value, label }))
          option.click($.proxy(tar.handleOptionClick, tar))
          div.append(option.unit)
          return option
        })
        tar.scroll.slot = div.children()
      }
    }
  },
  template: {
    select() {
      return $(`
      <div class="lt-select">
        <div id="tags" class="select__tags">
          <span id="tag">
            <tag>
              <span id="tagIn" class="select__tags-text"></span>
            </tag>
          </span>
        </div>
        <p id="empty" class="select-dropdown__empty"></p>
      </div>`)
    },
  },
  updater: {
    // 原生类
    name(value, opt, tar, node) {
      if (value || value === '') {
        tar.input.disabled = true
      } else {
        tar.input.disabled = false
      }
    },
    disabled(value, opt, tar, node) {
      if (value || value === '') {
        tar.input.disabled = true
      } else {
        tar.input.disabled = false
      }
    },
    // 基本类
    border(value, opt, tar, node) {
      if (value || value === '') {
        tar.unit.addClass('is-bordered')
      } else {
        tar.unit.removeClass('is-bordered')
      }
    },
    valueArray(value, opt, tar, node) {
      const { option = [] } = tar.members
      if ($.type(value) === 'string' && value) {
        tar.valueArray = value.split(',')
      } else if ($.type(value) === 'array') {
        option.some(obj => {
          obj.selected = value.includes(obj.value)
        })
      } else {
        tar.valueArray = []
      }
    },
    size(value, opt, tar, node) {
      tar.input.size = value
    },
    // 扩展类
    clearable(value, opt, tar, node) {
      tar.input.clearable = value
    },
    multiple(value, opt, tar, node) {
      if (value) {
        // TODO: 未完成
      } else {
        tar.members.tags.detach()
      }
    },
    filterable(value, opt, tar, node) {
      // TODO: 未完成
    },
  },
}

export default class Select extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      type: 'select', // 控件类型
      placeholder: '', // 原生属性: placeholder
      defaultData: [
        // 默认选项值
        { id: '1', text: '是' },
        { id: '0', text: '否' },
      ],
    }
    this.defaults = {
      name: '', // 原生属性: 控件名
      disabled: false, // 原生属性: 禁用(true/false)

      border: false, // 基本功能: 是否显示边框
      valueArray: [], // 基本功能: 值
      size: '', // 基本功能: 尺寸

      clearable: true, // 扩展功能: 是否可清空(true/false)
      multiple: false, // 扩展功能: 是否能多选
      filterable: false, // 扩展功能: 是否可搜索
    }
    this.events = {
      reset: null, // 重置data
      change: 'onChange', // input的值变化事件
      focus: 'onFocus', // input的获得焦点事件
      click: null, // input的点击事件
      shown: null, // 弹窗panel出现后事件
      hidden: null, // 弹窗panel隐藏后事件
    }
    this.settings = Object.assign({}, def, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const { type } = opt
    let template
    if (type === 'button') template = util.template.select(opt, this)
    else template = util.template.select(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.input = util.pullInput(opt, this)
    this.dropdown = util.pullDropdown(opt, this)
    this.scroll = util.pullScroll(opt, this)
    this.data = this.settings.data
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.input.click($.proxy(this.click, this))
    this.input.focus($.proxy(this.focus, this))
    this.input.blur($.proxy(this.blur, this))
    this.dropdown.shown($.proxy(this.handleShown, this))
    this.dropdown.hidden($.proxy(this.hidden, this))
    $(window).click($.proxy(this.handleDropdown, this))
  }

  handleShown(obj) {
    if (obj.show) {
      this.input.members.suffixIcon.addClass('is-reverse')
      this.hasLocation(this.unit, this.dropdown.unit, window)
      this.trimDropWidth(this.unit, this.dropdown.unit)
    } else {
      this.input.members.suffixIcon.removeClass('is-reverse')
    }
    this.shown()
  }

  handleDropdown(event) {
    const input = $(event.target).closest(this.input.members.input)
    const dropdown = $(event.target).closest(this.dropdown.unit)
    if (input.length > 0) {
      this.dropdown.show = true
    } else if (dropdown.length > 0) {
      this.dropdown.show = this.key
    } else if (event.target.tagName === 'BODY') {
    } else if (this.dropdown.show) {
      this.dropdown.show = false
    }
  }

  handleInputChange(obj) {
    if (!obj.value) {
      this.valueArray = ''
    } else {
      const arr = this.data
      const values = obj.value.split(',')
      const res = arr.map(x => {
        if (values.includes(x.text)) {
          return x.id
        }
      })
      this.key = false
      this.valueArray = res
    }
  }

  handleOptionClick(obj) {
    this.input.value = obj.label
    this.valueArray = [obj.value]
    this.input.members.input.focus()
    this.change()
  }

  onChange() {
    this.input.value = this.textContent
  }

  onFocus() {
    console.log(4)
    this.dropdown.show = true
  }

  set data(value = this.settings.defaultData) {
    this.settings.data = value
    util.pullOption(this.settings, this, this.settings.data)
  }

  get data() {
    return this.settings.data
  }

  set value(value) {
    this.valueArray = value
    this.input.value = this.textContent
  }

  get value() {
    return this.valueArray.join(',')
  }

  get textContent() {
    return this.data
      .filter(x => this.valueArray.includes(x.id))
      .map(x => x.text)
      .join(',')
  }
}
